var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('PageHeaderDesktop'),(!_vm.$store.state.showArticleOnly)?_c('TopMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }